/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
export default class Team {
  constructor({ htmlBody }) {
    this.htmlBody = htmlBody;
    this.member = this.htmlBody.find('.section__team--list-item');
    this.init();
  }

  init = () => {
    this.member.length && this.TeamPopUp();
  };

  TeamPopUp = () => {
    this.member.on('click', (e) => {
      const that = $(e.currentTarget);
      const title = that.find('.content .hidden .Name').text();
      const position = that.find('.content .hidden .Position').text();
      const link = that.find('.content .hidden .link-linkedin').text();
      const image = that.find('.section__overflow-content__image img').attr('largeimageone');
      console.log(image);
      const content = that.find('.content .hidden .desc').html();
      const template = `<div class="section__team__popup__wrapper wrapper">
                          <div class="section__team__popup">
                          <div data-fancybox-close class="section__team__popup-close"><i class="icon__close"></i></div>
                            <div class="section__team__popup-image">
                              <img src="${image}" alt="${title}" />
                            </div>
                            <div class="section__team__popup-content">
                            <div>
                              <h3>${title}</h3>
                              <h4>${position}</h4>                        
                              <p>${content}</p>
                            </div>
                            <a href="${link}" class="link-linkedin" target="_blank"><img src="	https://mag.1020dev.com/files/5116/8448/0077/linkedinlogo.png" alt="linkedin" /></a>
                            </div>
                          </div>                          
                        </div>`;
      const opts = {
        smallBtn: false,
        toolbar: false,
        padding: 0,
      };

      $.fancybox.open(template, opts);
    });
  }
}
